export const SESSIONS_CHART_SERIES = [{
    name: 'Sessions',
    // data: [17088, 16357, 17935, 13723, 14198, 13642, 15255],
    data: [
        {
            name: 'January 2023',
            y: 17088,
            color: '#FF5733' 
        },
        {
            name: 'February 2023',
            y: 16357,
            color: '#3498DB' 
        },
        {
            name: 'March 2023',
            y: 17935,
            color: '#27AE60' 
        },
        {
            name: 'April 2023',
            y: 13723,
            color: '#9B59B6' 
        },
        {
            name: 'May 2023',
            y: 14198,
            color: '#3498DB' 
        },
        {
            name: 'June 2023',
            y: 13642,
            color: '#27AE60' 
        },
        {
            name: 'July 2023',
            y: 15255,
            color: '#9B59B6' 
        }
    ]
}];

export const CREATIVE_TYPE_CHART_SERIES = [
    {
        name: 'Lymphoma Therapy Mobile',
        data: [
            0, 0, 0.01, 0,
            0, 0, 0
        ],
        fillColor: '#bf3f3f'
    },
    {
        name: 'Not Set',
        data: [
            88.79, 88.79,
            85.19, 47.9,
            34.36, 37.24,
            32.9
        ],
        fillColor: '#bf4c3f'
    },
    {
        name: 'USA_BI_SEM_B_EX_Yescarta-HCP-2L-Standard',
        data: [
            0.01, 0.01,
            0.02, 0.02,
            0.04, 0.05,
            0.04
        ],
        fillColor: '#bf593f'
    },
    {
        name: 'USA_BI_SEM_B_EX_Yescarta-HCP-DBLCL-Consideration-Standard',
        data: [
            0.65, 0.44,
            1.72, 2.19,
            0.56, 0.81,
            0.72
        ],
        fillColor: '#bf663f'
    },
    {
        name: 'USA_BI_SEM_B_EX_Yescarta-HCP-DBLCL-Conversion-Standard',
        data: [
            0.03, 0.04,
            0.15, 0.31,
            0.02, 0.03,
            0.31
        ],
        fillColor: '#bf733f'
    },
    {
        name: 'USA_BI_SEM_B_EX_Yescarta-HCP-DBLCL-Retention-Standard',
        data: [
            0, 0, 0.02,
            0.01, 0.02, 0,
            0.02
        ],
        fillColor: '#bf803f'
    },
    {
        name: 'USA_BI_SEM_B_EX_Yescarta_HCP_FL_Branded Core_Standard',
        data: [
            0, 0, 0,
            0, 0.14, 0.14,
            0.27
        ],
        fillColor: '#bf8d3f'
    },
    {
        name: 'USA_BI_SEM_B_EX_Yescarta_HCP_FL_Branded Info_Standard',
        data: [
            0, 0, 0,
            0, 0.06, 0.05,
            0.18
        ],
        fillColor: '#bf9a3f'
    },
    {
        name: 'USA_BI_SEM_B_EX_Yescarta_HCP_FL_Branded Treatment_Standard',
        data: [
            0, 0, 0,
            0, 0, 0.05,
            0.15
        ],
        fillColor: '#bfa73f'
    },
    {
        name: 'USA_BI_SEM_B_PH_Yescarta-HCP-2L-Standard',
        data: [
            0.13, 0.04,
            0.15, 0.04,
            0.09, 0.06,
            0.04
        ],
        fillColor: '#bfb43f'
    },
    {
        name: 'USA_BI_SEM_B_PH_Yescarta-HCP-DBLCL-Consideration-Standard',
        data: [
            0.18, 0.16,
            0.49, 0.59,
            0.33, 1.01,
            4.42
        ],
        fillColor: '#bdbf3f'
    },
    {
        name: 'USA_BI_SEM_B_PH_Yescarta-HCP-DBLCL-Conversion-Standard',
        data: [
            0.24, 0.19,
            0.35, 0.79,
            0.39, 0.38,
            3.19
        ],
        fillColor: '#b0bf3f'
    },
    {
        name: 'USA_BI_SEM_B_PH_Yescarta-HCP-DBLCL-Retention-Standard',
        data: [
            0.03, 0.01, 0.03,
            0.28, 0.1, 0.42,
            2.93
        ],
        fillColor: '#a3bf3f'
    },
    {
        name: 'USA_BI_SEM_B_PH_Yescarta_HCP_FL_Branded Core_Standard',
        data: [
            0.02, 0, 0.02,
            0, 0, 0,
            0
        ],
        fillColor: '#96bf3f'
    },
    {
        name: 'USA_BI_SEM_B_PH_Yescarta_HCP_FL_Branded Info_Standard',
        data: [
            0, 0, 0.09,
            0.01, 0.01, 0,
            0.01
        ],
        fillColor: '#89bf3f'
    },
    {
        name: 'USA_BI_SEM_B_PH_Yescarta_HCP_FL_Branded Symptoms_Standard',
        data: [
            0, 0, 0, 0,
            0.01, 0, 0
        ],
        fillColor: '#7cbf3f'
    },
    {
        name: 'USA_BI_SEM_B_PH_Yescarta_HCP_FL_Branded Treatment_Standard',
        data: [
            0.06, 0.21,
            0.05, 0.27,
            0.18, 0.12,
            3.52
        ],
        fillColor: '#6fbf3f'
    },
    {
        name: 'USA_BI_SEM_C_EX_Yescarta-HCP-2L-Standard',
        data: [
            0.47, 0.68, 0.68,
            0.95, 0.37, 0.4,
            0.48
        ],
        fillColor: '#62bf3f'
    },
    {
        name: 'USA_BI_SEM_C_PH_Yescarta-HCP-2L-Standard',
        data: [
            1.9, 1.34, 0.78,
            4.76, 6.19, 3.34,
            3.15
        ],
        fillColor: '#55bf3f'
    },
    {
        name: 'USA_BI_SEM_C_PH_Yescarta_HCP_FL_Competitor_Standard',
        data: [
            0.02, 0, 0.01,
            0, 0, 0,
            0
        ],
        fillColor: '#48bf3f'
    },
    {
        name: 'USA_BI_SEM_NB_EX_Yescarta-HCP-DBLCL-Awareness-Standard',
        data: [
            0.53, 1.89,
            1.57, 2.11,
            0.51, 0.36,
            1.25
        ],
        fillColor: '#3fbf44'
    },
    {
        name: 'USA_BI_SEM_NB_EX_Yescarta-HCP-FL-Unbranded-Core-Standard',
        data: [
            1.05, 0.22,
            1.41, 1.12,
            0.92, 0.54,
            0.31
        ],
        fillColor: '#3fbf51'
    },
    {
        name: 'USA_BI_SEM_NB_EX_Yescarta-HCP-FL-Unbranded-Info-Standard',
        data: [
            0.01, 0, 0, 0,
            0, 0, 0
        ],
        fillColor: '#3fbf5e'
    },
    {
        name: 'USA_BI_SEM_NB_EX_Yescarta-HCP-FL-Unbranded-Symptoms-Standard',
        data: [
            0.02, 0.02, 0.09,
            0.02, 0.01, 0,
            0
        ],
        fillColor: '#3fbf6a'
    },
    {
        name: 'USA_BI_SEM_NB_EX_Yescarta-HCP-FL-Unbranded-Treatment-Standard',
        data: [
            0.01, 0.15,
            0.21, 0.34,
            0.27, 0.45,
            0.23
        ],
        fillColor: '#3fbf77'
    },
    {
        name: 'USA_BI_SEM_NB_PH_Yescarta-HCP-DBLCL-Awareness-Standard',
        data: [
            4.32, 5.11,
            4.53, 3.62,
            6.35, 5.18,
            6.25
        ],
        fillColor: '#3fbf84'
    },
    {
        name: 'USA_BI_SEM_NB_PH_Yescarta-HCP-FL-Unbranded-Core-Standard',
        data: [
            1.31, 0.01, 0.17,
            0.71, 1.37, 1.14,
            1.1
        ],
        fillColor: '#3fbf91'
    },
    {
        name: 'USA_BI_SEM_NB_PH_Yescarta-HCP-FL-Unbranded-Info-Standard',
        data: [
            0.01, 0.01, 0.02,
            0.07, 0.01, 0.01,
            0
        ],
        fillColor: '#3fbf9e'
    },
    {
        name: 'USA_BI_SEM_NB_PH_Yescarta-HCP-FL-Unbranded-Symptoms-Standard',
        data: [
            0.04, 0.34,
            0.69, 0.04,
            0.01, 0.01,
            0.01
        ],
        fillColor: '#3fbfab'
    },
    {
        name: 'USA_BI_SEM_NB_PH_Yescarta-HCP-FL-Unbranded-Treatment-Standard',
        data: [
            0.04, 0.34,
            0.37, 0.98,
            1.22, 1.22,
            1.07
        ],
        fillColor: '#3fbfb8'
    },
    {
        name: 'USA_GO_SEM_B_EX_Yescarta-HCP-2L-Standard',
        data: [
            0, 0, 0,
            0.06, 0.06, 0.09,
            0.07
        ],
        fillColor: '#3fb8bf'
    },
    {
        name: 'USA_GO_SEM_B_EX_Yescarta-HCP-DBLCL-Consideration-Standard',
        data: [
            0, 0, 0,
            0.79, 1.71, 1.76,
            1.73
        ],
        fillColor: '#3fabbf'
    },
    {
        name: 'USA_GO_SEM_B_EX_Yescarta-HCP-DBLCL-Conversion-Standard',
        data: [
            0, 0, 0,
            0.09, 0.14, 0.1,
            0.12
        ],
        fillColor: '#3f9ebf'
    },
    {
        name: 'USA_GO_SEM_B_EX_Yescarta_HCP_FL_Branded-Core_Standard',
        data: [
            0, 0, 0,
            0.66, 1.09, 1.27,
            0.13
        ],
        fillColor: '#3f91bf'
    },
    {
        name: 'USA_GO_SEM_B_PH_Yescarta-HCP-2L-Standard',
        data: [
            0, 0, 0,
            0.01, 0.14, 0.1,
            0.06
        ],
        fillColor: '#3f84bf'
    },
    {
        name: 'USA_GO_SEM_B_PH_Yescarta-HCP-DBLCL-Consideration-Standard',
        data: [
            0, 0, 0,
            0.66, 1.78, 1.52,
            1.18
        ],
        fillColor: '#3f77bf'
    },
    {
        name: 'USA_GO_SEM_B_PH_Yescarta-HCP-DBLCL-Conversion-Standard',
        data: [
            0, 0, 0,
            0.52, 0.62, 0.7,
            0.58
        ],
        fillColor: '#3f6abf'
    },
    {
        name: 'USA_GO_SEM_B_PH_Yescarta_HCP_FL_Branded-Core_Standard',
        data: [
            0, 0, 0,
            0.03, 0.06, 0,
            0.02
        ],
        fillColor: '#3f5ebf'
    },
    {
        name: 'USA_GO_SEM_C_EX_Yescarta-HCP-2L-Standard',
        data: [
            0, 0, 0, 0,
            0, 0, 0.01
        ],
        fillColor: '#3f51bf'
    },
    {
        name: 'USA_GO_SEM_C_EX_Yescarta_HCP_FL_Competitor_Standard',
        data: [
            0, 0, 0,
            0.01, 0, 0.04,
            0.07
        ],
        fillColor: '#3f44bf'
    },
    {
        name: 'USA_GO_SEM_C_PH_Yescarta-HCP-2L-Standard',
        data: [
            0, 0, 0,
            0.36, 0.51, 0.53,
            0.41
        ],
        fillColor: '#483fbf'
    },
    {
        name: 'USA_GO_SEM_C_PH_Yescarta_HCP_FL_Competitor_Standard',
        data: [
            0, 0, 0,
            0.29, 0.56, 0.49,
            0.42
        ],
        fillColor: '#553fbf'
    },
    {
        name: 'USA_GO_SEM_NB_EX_Yescarta-HCP-DBLCL-Awareness-Standard',
        data: [
            0, 0, 0,
            4.71, 8.54, 9.3,
            6.59
        ],
        fillColor: '#623fbf'
    },
    {
        name: 'USA_GO_SEM_NB_EX_Yescarta-HCP-DLBCL-3L-Awareness-Standard',
        data: [
            0, 0, 0,
            0, 0.02, 0.01,
            0.03
        ],
        fillColor: '#6f3fbf'
    },
    {
        name: 'USA_GO_SEM_NB_EX_Yescarta-HCP-FL-Unbranded-Core-Standard',
        data: [
            0, 0, 0,
            2.68, 3.92, 4.45,
            3.43
        ],
        fillColor: '#7c3fbf'
    },
    {
        name: 'USA_GO_SEM_NB_EX_Yescarta-HCP-FL-Unbranded-Info-Standard',
        data: [
            0, 0, 0,
            0, 0.02, 0,
            0.01
        ],
        fillColor: '#893fbf'
    },
    {
        name: 'USA_GO_SEM_NB_EX_Yescarta-HCP-FL-Unbranded-Symptoms-Standard',
        data: [
            0, 0, 0,
            0.04, 0.07, 0.04,
            0.04
        ],
        fillColor: '#963fbf'
    },
    {
        name: 'USA_GO_SEM_NB_EX_Yescarta-HCP-FL-Unbranded-Treatment-Standard',
        data: [
            0, 0, 0,
            0, 0.04, 0,
            0.04
        ],
        fillColor: '#a33fbf'
    },
    {
        name: 'USA_GO_SEM_NB_PH_Yescarta-HCP-DBLCL-Awareness-Standard',
        data: [
            0, 0, 0,
            17.74, 21.52, 20.77,
            15.56
        ],
        fillColor: '#b03fbf'
    },
    {
        name: 'USA_GO_SEM_NB_PH_Yescarta-HCP-DLBCL-3L-Awareness-Standard',
        data: [
            0, 0, 0,
            0.01, 0.01, 0.01,
            0.03
        ],
        fillColor: '#bd3fbf'
    },
    {
        name: 'USA_GO_SEM_NB_PH_Yescarta-HCP-FL-Unbranded-Core-Standard',
        data: [
            0, 0, 0,
            2.46, 3.88, 3.57,
            3.22
        ],
        fillColor: '#bf3fb4'
    },
    {
        name: 'USA_GO_SEM_NB_PH_Yescarta-HCP-FL-Unbranded-Info-Standard',
        data: [
            0, 0, 0, 0,
            0.01, 0, 0
        ],
        fillColor: '#bf3fa7'
    },
    {
        name: 'USA_GO_SEM_NB_PH_Yescarta-HCP-FL-Unbranded-Symptoms-Standard',
        data: [
            0, 0, 0,
            0.42, 0.49, 0.55,
            0.69
        ],
        fillColor: '#bf3f9a'
    },
    {
        name: 'USA_GO_SEM_NB_PH_Yescarta-HCP-FL-Unbranded-Treatment-Standard',
        data: [
            0, 0, 0,
            0.09, 0.04, 0,
            0.07
        ],
        fillColor: '#bf3f8d'
    },
    {
        name: 'USA_MA_SEM_B_EX_Yescarta-HCP-DLBCL-3L-Brand-Standard',
        data: [
            0, 0, 0, 0,
            0, 0, 0.14
        ],
        fillColor: '#bf3f80'
    },
    {
        name: 'USA_MA_SEM_B_PH_Yescarta-HCP-DLBCL-3L-Brand-Standard',
        data: [
            0.01, 0.01, 0.01,
            0, 0.01, 0,
            0.12
        ],
        fillColor: '#bf3f73'
    },
    {
        name: 'USA_MA_SEM_NB_EX_Yescarta-HCP-DLBCL-3L-Awareness-Standard',
        data: [
            0, 0, 0.49,
            0.03, 0.01, 0.01,
            0.07
        ],
        fillColor: '#bf3f66'
    },
    {
        name: 'USA_MA_SEM_NB_PH_Yescarta-HCP-DLBCL-3L-Awareness-Standard',
        data: [
            0.15, 0.01, 0.77,
            0.13, 0.03, 0.59,
            1.7
        ],
        fillColor: '#bf3f59'
    },
    {
        name: 'us_2023_onc-yescarta-hcp_branded_digital_awareness_na',
        data: [
            0, 0, 0,
            1.07, 1.2, 1.12,
            0.94
        ],
        fillColor: '#bf3f4c'
    }
];

export const X_AXIS_CATEGORIES = ['January 2023', 'February 2023', 'March 2023', 'April 2023', 'May 2023', 'June 2023', 'July 2023'];

export const CREATIVE_NAME_CHART_SERIES = [{
    name: 'Sessions',
    data: [
        { x: 'Jan', y: 44 },
        { x: 'Feb', y: 48 },
        { x: 'Mar', y: 52 },
        { x: 'Apr', y: 56 },
        { x: 'May', y: 60 },
        { x: 'Jun', y: 64 },
        { x: 'Jul', y: 68 },
        { x: 'Aug', y: 72 },
        { x: 'Sep', y: 74 },
        { x: 'Oct', y: 76 },
        { x: 'Nov', y: 80 },
        { x: 'Dec', y: 84 }
    ]
}, {
    name: 'Quality Visits',
    data: [
        { x: 'Jan', y: 24 },
        { x: 'Feb', y: 28 },
        { x: 'Mar', y: 32 },
        { x: 'Apr', y: 36 },
        { x: 'May', y: 40 },
        { x: 'Jun', y: 44 },
        { x: 'Jul', y: 48 },
        { x: 'Aug', y: 50 },
        { x: 'Sep', y: 54 },
        { x: 'Oct', y: 58 },
        { x: 'Nov', y: 62 },
        { x: 'Dec', y: 66 }
    ]
}];

export const CREATIVE_NAME_CHART_OPTIONS = {
    chart: {
        type: 'area',
        toolbar: {
            show: false,
            tools: {
                download: false,
                selection: false,
                zoom: false,
                zoomin: false,
                zoomout: false,
                pan: false
            }
        }
    },
    noData: {
        text: 'No data to display',
        align: 'center',
        verticalAlign: 'middle',
        offsetX: 0,
        offsetY: 0,
        style: {
            color: '#000000',
            fontSize: '14px'
        }
    },
    colors: ['#FEC84B','#6CE9A6','#9EA5D1'],
    dataLabels: { enabled: false },
    stroke: { curve: 'smooth' },
    xaxis: {
        title: {
            text: 'Months',
            style: {
                color: '#667085',
                fontSize: '12px',
                fontFamily: 'Lucida Grande, Lucida Sans Unicode, Arial, Helvetica, sans-serif',
                fontWeight: 500,
                cssClass: 'apexcharts-xaxis-title'
            }
        },
        labels: {
            style: {
                colors: Array.from({ length: 20 })?.map(()=> '#667085'),
                fontSize: '12px',
                fontFamily: 'Lucida Grande, Lucida Sans Unicode, Arial, Helvetica, sans-serif',
                fontWeight: 400,
                cssClass: 'apexcharts-xaxis-label'
            }
        },
        crosshairs: { show: false }
    },
    yaxis: {
        title: {
            text: 'No. of Sessions and Quality Visits',
            style: {
                color: '#667085',
                fontSize: '12px',
                fontFamily: 'Lucida Grande, Lucida Sans Unicode, Arial, Helvetica, sans-serif',
                fontWeight: 500,
                cssClass: 'apexcharts-yaxis-title'
            }
        },
        labels: {
            style: {
                colors: ['#667085'],
                fontSize: '12px',
                fontFamily: 'Lucida Grande, Lucida Sans Unicode, Arial, Helvetica, sans-serif',
                fontWeight: 400,
                cssClass: 'apexcharts-yaxis-label'
            }
        },
        // labels: {
        //     formatter: function (val) {
        //         return val.toFixed(0) + '%';
        //     },
        // },
        tickAmount: 4,
        min: 0
        // max: 8,
    },
    grid: { show: false },
    tooltip: { enabled: true },
    legend: {
        show: true,
        position: 'top',
        horizontalAlign: 'center'
    }
};
